import { render } from "./consultation1.vue?vue&type=template&id=51a6d92c&scoped=true"
import script from "./consultation1.vue?vue&type=script&lang=js"
export * from "./consultation1.vue?vue&type=script&lang=js"

import "./consultation1.vue?vue&type=style&index=0&id=51a6d92c&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a6d92c"]])

export default __exports__